import { z } from 'zod';
export const assignOrgRoleFromGroupContextBodySchema = z.object({
    roleId: z.string().uuid(),
});
//# sourceMappingURL=assign-org-role-from-group-context.schema.js.map